import apiRequest from './requestBase';

const localizeContent = (tableId: string, columnName: string, rowId: string, locale: string) => {
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  return apiRequest({
    headers,
    url: `/api/alltrails/localizations?table=${tableId}&columnName=${columnName}&rowId=${rowId}`
  });
};

export { localizeContent };
